"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>__WEBPACK_DEFAULT_EXPORT__
});
const UseRefreshSessionAccess = ()=>{
    if ('undefined' == typeof window) return;
    const oktaToken = localStorage.getItem('okta-token-storage');
    const tokenJson = JSON.parse(oktaToken);
    const customerId = tokenJson?.idToken?.claims['com.priceline.profile.custId'];
    const custName = tokenJson?.idToken?.claims.name?.replace(/\s/g, '');
    const sessionStatus = localStorage.getItem('sessionStatus');
    if (customerId && custName) {
        localStorage.setItem('psid', `${custName}-${customerId}`);
        localStorage.setItem('sessionStatus', 'true');
    } else if ('true' === sessionStatus) {
        localStorage.removeItem('psid');
        sessionStorage.removeItem('pennysid');
        localStorage.setItem('sessionStatus', 'false');
    }
    return {};
};
const __WEBPACK_DEFAULT_EXPORT__ = UseRefreshSessionAccess;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
